import { createGlobalStyle } from 'styled-components';
import { accentPrimary } from 'constants/theme';
import {
  backgroundPrimary,
  barlowFont,
  black,
  firaFont,
} from './constants/theme';

export default createGlobalStyle`
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    &:focus {
      outline: none;
    }
  }

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  *, *::after, *::before {
    box-sizing: inherit;
  }

  html {
    font-size: 62.5%;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  body {
    font-family: ${firaFont};
    line-height: 1;
    font-size: 1.6rem;
    color: ${black};
    background-color: ${backgroundPrimary};
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    -webkit-font-feature-settings: "pnum";
    font-feature-settings: "pnum";
    font-variant-numeric: proportional-nums;
  }

  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${barlowFont};
  }

  a {
    cursor: pointer;
    color: ${accentPrimary};
    &:focus {
      outline: none !important;
      text-decoration: none !important;
    }
  }

  button {
    border: none;
    font-family: ${firaFont};
  }

  pre {
    display: block;
    padding: 2rem;
    margin-top: 4rem;
    overflow: auto;
    font-size: 85%;
    line-height: 1.45;
    border-radius: 5px;
    color: ${accentPrimary};
    border: 1px solid #ddd;
    font-family: "SFMono-Regular",Consolas,"Liberation Mono",Menlo,Courier,monospace;
  }

  img, video {
    width: 100%;
  }
`;
